import { render, staticRenderFns } from "./TextHider.vue?vue&type=template&id=ee242d0e&scoped=true"
import script from "./TextHider.vue?vue&type=script&lang=js"
export * from "./TextHider.vue?vue&type=script&lang=js"
import style0 from "./TextHider.vue?vue&type=style&index=0&id=ee242d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee242d0e",
  null
  
)

export default component.exports